import trainer1 from '../image/instructors/1-1.jpg'
import trainer2 from '../image/instructors/img-1.jpg'
import trainer3 from '../image/instructors/img-4.jpg'
import trainer4 from '../image/instructors/team-4.jpg'
import trainer5 from '../image/instructors/team2201.jpg'
import trainer6 from '../image/instructors/team-1.jpg'
import trainer7 from '../image/instructors/team-details.png'
import { FaFacebook, FaInstagram, FaTwitter } from 'react-icons/fa6';

export const instructors = [
               {
                              id: 1,
                              img: trainer5,
                              name: 'Mike Johnson',
                              positon: 'CEO/Founder',
                              social: [
                                             {
                                                            id: 1,
                                                            link: <FaFacebook />
                                             },
                                             {
                                                            id: 2,
                                                            link: <FaInstagram />
                                             },
                                             {
                                                            id: 1,
                                                            link: <FaTwitter />
                                             }
                              ]
               },
               {
                              id: 2,
                              img: trainer3,
                              name: 'Samuel Ethan',
                              positon: 'YOGA COACH',
                              social: [
                                             {
                                                            id: 1,
                                                            link: <FaFacebook />
                                             },
                                             {
                                                            id: 2,
                                                            link: <FaInstagram />
                                             },
                                             {
                                                            id: 1,
                                                            link: <FaTwitter />
                                             }
                              ]
               },
               {
                              id: 3,
                              img: trainer2,
                              name: 'Abigial Hannah',
                              positon: 'CEO/Founder',
                              social: [
                                             {
                                                            id: 1,
                                                            link: <FaFacebook />
                                             },
                                             {
                                                            id: 2,
                                                            link: <FaInstagram />
                                             },
                                             {
                                                            id: 1,
                                                            link: <FaTwitter />
                                             }
                              ]
               },
               {
                              id: 4,
                              img: trainer1,
                              name: 'Milona Digits',
                              positon: 'Body Building Expert',
                              social: [
                                             {
                                                            id: 1,
                                                            link: <FaFacebook />
                                             },
                                             {
                                                            id: 2,
                                                            link: <FaInstagram />
                                             },
                                             {
                                                            id: 1,
                                                            link: <FaTwitter />
                                             }
                              ]
               },
               {
                              id: 5,
                              img: trainer4,
                              name: 'Eleanor Grace',
                              positon: 'YOGA COACH',
                              social: [
                                             {
                                                            id: 1,
                                                            link: <FaFacebook />
                                             },
                                             {
                                                            id: 2,
                                                            link: <FaInstagram />
                                             },
                                             {
                                                            id: 1,
                                                            link: <FaTwitter />
                                             }
                              ]
               },
               {
                              id: 6,
                              img: trainer6,
                              name: 'Molisha Daniel',
                              positon: 'Health Educator',
                              social: [
                                             {
                                                            id: 1,
                                                            link: <FaFacebook />
                                             },
                                             {
                                                            id: 2,
                                                            link: <FaInstagram />
                                             },
                                             {
                                                            id: 1,
                                                            link: <FaTwitter />
                                             }
                              ]
               },
               {
                              id: 7,
                              img: trainer7,
                              name: 'Jecob Thomas',
                              positon: 'Nutritionist',
                              social: [
                                             {
                                                            id: 1,
                                                            link: <FaFacebook />
                                             },
                                             {
                                                            id: 2,
                                                            link: <FaInstagram />
                                             },
                                             {
                                                            id: 1,
                                                            link: <FaTwitter />
                                             }
                              ]
               },
]